import React from 'react';
import classNames from 'classnames';

import './dropdown-list.scss';

interface DropdownListProps {
    list: { label: string; value: string; isDisabled?: boolean; className?: string; }[];
    onSelect: (value: string) => void;
    selectedValue?: string;
    hideSelectedItems?: boolean;
}

const DropdownList: React.FC<DropdownListProps> = ({ list, selectedValue, onSelect, hideSelectedItems }) => (
    <div className="dropdown-list">
        {list.map(item => (
            <button
                type="button"
                key={item.value}
                tabIndex={0}
                onClick={item.isDisabled ? void 0 : (): void => onSelect(item.value)}
                className={classNames('dropdown-list__item', {
                    'dropdown-list__item--disabled': item.isDisabled,
                    'dropdown-list__item--selected': item.value === selectedValue,
                    'dropdown-list__item--hidden': item.value === selectedValue && hideSelectedItems
                }, item.className)}
            >
                {item.label}
            </button>
        ))}
    </div>
);

export default DropdownList;
